/**
 * Componente: Configuración del método de carga de foto (admin)
 * Elige el método único con el que los operadores van a cargar la foto del
 * contribuyente en este municipio: cámara o archivo. Mientras no se elija
 * ninguno (metodo_captura_foto en NULL), el formulario de contribuyente
 * ofrece las dos opciones como fallback seguro.
 */

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Camera, Upload } from 'lucide-react';
import { IconCerrar, IconAdvertencia } from './icons';

const API_URL = process.env.REACT_APP_API_URL;

const ConfiguracionFotoModal = ({ onClose, onGuardado }) => {
  const [metodo, setMetodo] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const cargar = async () => {
      try {
        setCargando(true);
        const token = sessionStorage.getItem('token');
        const { data } = await axios.get(`${API_URL}/municipios/configuracion`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setMetodo(data.metodo_captura_foto);
      } catch (err) {
        console.error('Error al cargar la configuración:', err);
        setError(err.response?.data?.mensaje || 'Error al cargar la configuración');
      } finally {
        setCargando(false);
      }
    };
    cargar();
  }, []);

  const guardar = async () => {
    if (!metodo) {
      setError('Elegí un método');
      return;
    }
    try {
      setGuardando(true);
      setError('');
      const token = sessionStorage.getItem('token');
      await axios.put(
        `${API_URL}/municipios/configuracion`,
        { metodo_captura_foto: metodo },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      onGuardado(metodo);
    } catch (err) {
      console.error('Error al guardar la configuración:', err);
      setError(err.response?.data?.mensaje || 'Error al guardar la configuración');
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content configuracion-impresion-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Método de carga de foto</h2>
          <button className="modal-close" onClick={onClose}><IconCerrar size={18} /></button>
        </div>

        <div className="modal-body">
          <p className="form-hint">
            Elegí cómo van a cargar la foto del contribuyente en el formulario de Padrón. Aplica a todos los operadores de este municipio.
          </p>

          {error && (
            <div className="alert alert-error">
              <IconAdvertencia size={18} />
              <p>{error}</p>
            </div>
          )}

          {cargando ? (
            <div className="padron-loading">
              <div className="loading-spinner"></div>
            </div>
          ) : (
            <div className="opciones-grid">
              <button
                type="button"
                className={`opcion-card ${metodo === 'camara' ? 'seleccionada' : ''}`}
                onClick={() => setMetodo('camara')}
              >
                <Camera className="opcion-icono" size={40} strokeWidth={1.5} />
                <span className="opcion-texto">Tomar foto con cámara</span>
              </button>
              <button
                type="button"
                className={`opcion-card ${metodo === 'archivo' ? 'seleccionada' : ''}`}
                onClick={() => setMetodo('archivo')}
              >
                <Upload className="opcion-icono" size={40} strokeWidth={1.5} />
                <span className="opcion-texto">Subir archivo</span>
              </button>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button type="button" className="btn-cancelar" onClick={onClose} disabled={guardando}>
            Cancelar
          </button>
          <button type="button" className="btn-guardar" onClick={guardar} disabled={guardando || cargando}>
            {guardando ? 'Guardando...' : 'Guardar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfiguracionFotoModal;
